module.exports = __webpack_public_path__ + "static/media/icon-partners.2e6d7285.svg";